<template>
  <div class="main" >
    <div class="content">
    <div  class="content1" v-for="(item,index) in data" >
      <div v-if="item.txdm !='-1'">
      <div class="title" v-html="">{{index+1}}、{{item.zbmc}}<span style="color:red;">【{{item.zbfz}}】{{item.sfbt == 1 ? ' *' : ''}}</span>
        <a  v-if="item.xxsm == 1" @click="getzbxx(item)" style="display:inline-block;line-height:14px;width:12px;height:12px;font-size:9px;color:#888;border:1px solid #888;border-radius:12px;text-align:center;">?</a>
      </div>
      <!-- 多选 -->
      <van-checkbox-group v-if="item.txdm=='2'"  v-model="item.examansws">
        <van-checkbox
          v-for="(m,n) in item.selections"
          :key="m.zbxmdm"
          shape="square"
          :name="'{|zbxmdm|:|'+m.zbxmdm+'|,|zbxmmc|:|'+m.zbxmmc+'|,|fz|:|'+m.fzbl*item.zbfz/100+'|}'"
        >{{ m.zbxmmc }}</van-checkbox>
      </van-checkbox-group>
     <!--简答题-->
      <van-field v-if="item.txdm=='3'"
        v-model="item.examansws[0]"
        rows="3"
        autosize
        label=""
        border
        type="textarea"
        placeholder="请输入"
        show-word-limit
      />
      <!--滑块-->
      <van-slider v-model="item.examansws[0]"  active-color="#1989fa" bar-height="15px"   :min="item.minzbfz" :max="item.maxzbfz"  v-if="item.txdm =='4'" >
        <template #button>
          <div class="custom-button">{{ item.examansws[0] }}分</div>
        </template>
      </van-slider>
      <!--星星-->
      <van-rate
        v-model="item.examansws[0]"
        :size="25"
        v-if="item.txdm=='5'"
        color="#ffd21e"
        :count="item.selections.length"
        void-icon="star"
        void-color="#eee"
      />
        <!-- 评分 -->
        <van-field v-if="item.txdm=='6'" type="number" autosize v-model="item.examansws[0]"  placeholder="请输入分值" />
        <!--日期-->
        <van-cell   v-if="item.txdm=='9'" icon="calendar-o" title="日期" title-style="color:#1989fa;font-size:16px" :value="date" @click="opencalendar(index)" is-link />
        <van-calendar v-if="item.txdm=='9'"
          v-model="clandshow" color="#1989fa"
          @confirm="calendConfirm"
        />
      <!-- 单选 -->
      <div v-if="item.txdm =='1'">
      <van-radio-group  v-if="item.selections.length<=5"  v-model="item.examansws[0]" :key="index">
        <van-radio
          v-for="(m,n) in item.selections"
          :key="m.zbxmdm"
          :name="'{|zbxmdm|:|'+m.zbxmdm+'|,|zbxmmc|:|'+m.zbxmmc+'|,|fz|:|'+m.fzbl*item.zbfz/100+'|}'"
        >
          <span  v-html="m.zbxmmc" ></span>
        </van-radio>
      </van-radio-group>

        <van-dropdown-menu v-if="item.selections.length>5" :key="index" active-color="#1989fa">
          <van-dropdown-item v-model="item.examansws[0]" :options="selectpz(item.selections,item,index)" />
        </van-dropdown-menu>

      </div>
      </div>
      <div v-if="item.txdm=='-1' && (item.zblxdm =='' && item.bz == ''?false:true)">
        <div class="title">{{data.length}}、评分说明：<span style="color:red;"></span>
        </div>
      <van-field v-model="item.examansws"
                 rows="3"
                 autosize
                 label=""
                 border
                 type="textarea"
                 placeholder="请输入"
                 show-word-limit
      />
      </div>
  </div>
    </div>
    <van-dialog v-model="show" title="指标说明" :showConfirmButton="false" :showCancelButton="true">
      <div style="margin-right: 10px;margin-left: 10px;margin-bottom: 10px;font-size: 14px">
        <van-loading type="spinner" style="text-align: center" color="#1989fa" v-if="ckloading" key="ckloading" />
        <div>指标：{{ckdatalist.zbmc}}</div>
        <div style="margin-top: 10px">说明：{{ckdatalist.xxsm==null || ckdatalist.xxsm==''?'暂无说明':ckdatalist.xxsm}}</div>
      </div>
    </van-dialog>
    <van-tabbar v-model="btactive" active-color="#7d7e80">
      <van-tabbar-item icon="share"  @click="savewj">提交</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import {Dialog, Notify} from 'vant';
export default {
  name: 'mobile-evaluate',
  props: {
    text: {
      type: String,
      default: ''
    },
    data:{
      type: Array,
      default: () => []
    },
    callbak: {
      type: Function,
      default: null,
    }
  },
  data() {
    return {
      show:false,
      pfsmis:false,
      ckdatalist:{zbmc:null,xxsm:null},
      ckloading:false,
      clandshow:false,
      date:null,
      btactive:0,
      showPopover:false,
      dateindex:0,
      wjpf:0,
      ts:false,// 是否有问答没填写
      ff:false,// 是否选了负分题
    }
  },
  methods:{
    getzbxx(item)
    {
      let that = this;
      this.ckloading = true;
      this.ckdatalist = {zbmc:null,xxsm:null};
      this.show = true;
      let datas = {zbdm:item.zbdm};
      this.$ajax.post('/appapi/teacherjspjwj/xxsm', datas).then(function (res) {
        if (res.code == 200) {
          that.ckdatalist = res.zbxx;
          that.ckloading = false;
        }
      })
    },
    calendConfirm(value){
      this.clandshow = false;
      this.date = this.$utils.formatDate(value);
      this.data[this.dataindex].examansws=this.date;
    },
    selectpz(options,item,indexs)
    {
      let  option1 =[]
      options.forEach((it,index) =>
      {
        option1.push({text:it.zbxmmc,value:"{|zbxmdm|:|"+it.zbxmdm+"|,|fz|:|"+it.fzbl*item.zbfz/100+"|,|zbxmmc|:|"+it.zbxmmc+"|}" })
      })
      return option1;
    },
    opencalendar(index)
    {
      this.clandshow = true;
      this.dataindex=index;
    },
    savewj()
    {
      // 收集数据，并判断是否有题目未评价
      let yxztm = new Array();
      // 收集未填写问答数据
      let wxzwd = new Array();
      // 收集单选多选星星，判断是否选择的同一项
      let xztmsy = new Array();
      let wxztm = []; // 未选择题目题号
      this.wjpf = 0.0;
      let thisQuestionnaireHasR =0;//评分限制条件
      let zdf = "";
      let zgf = "";
      let smzdf = "";
      let smzgf = "";
      let pfsm ="";
      this.data.forEach((item,index) => {
        let required = item.sfbt == '1';
        if (item.txdm == '2')//多选
        {
          if (item.examansws.length > 0) {
            let selectedZbxmdm = [];
            let selectedZbxmmc = [];
            let fz = 0.0;
            for (let dxit of item.examansws) {
              let zbmxval = JSON.parse(dxit.replaceAll(/\|/g, '"'));
              selectedZbxmdm.push(zbmxval.zbxmdm);
              selectedZbxmmc.push(zbmxval.zbxmmc);
              fz += parseFloat(zbmxval.fz);
              xztmsy.push({index: index});
            }
            // 选中负分就必须填写意见建议
            if (fz < 0) {
              this.ff = true;
            }
            yxztm.push({
              txdm: item.txdm,
              zbdm: item.zbdm,
              zbmc: item.zbmc,
              zbxmdm: selectedZbxmdm.join(','),
              fz: fz,
              dtjg: selectedZbxmmc.join(',')
            });
            this.wjpf = this.wjpf + fz;
          } else {
            if (required) {
              wxztm.push(index + 1)
            }
          }

        } else if (item.txdm == "3") //textarea
        {
          if (item.examansws.length == 0 || item.examansws == "") {
            if (required) {
              wxztm.push(index + 1);
            } else {
              wxzwd.push(index + 1);
              this.ts = true;
            }
          } else {
            yxztm.push({
              txdm: item.txdm,
              zbdm: item.zbdm,
              zbmc: item.zbmc,
              fz: parseFloat(item.zbfz),
              dtjg: item.examansws+""
            });
            this.wjpf = this.wjpf + parseFloat(item.zbfz);
          }
        } else if (item.txdm == "4") //滑块打分
        {
          if (item.examansws.length == 0 || item.examansws == "") {
            if (required) {
              wxztm.push(index + 1);
            }
          } else {
            let fz = parseFloat(item.examansws) * item.zbfz / 100;
            yxztm.push({
              txdm: item.txdm,
              zbdm: item.zbdm,
              zbmc: item.zbmc,
              fz: fz,
              dtjg: item.examansws+""
            });
            // 选中负分就必须填写意见建议
            if (fz < 0) {
              this.ff = true;
            }
            this.wjpf = this.wjpf + fz;

          }
        } else if (item.txdm == "5") //星星打分
        {
          if (item.examansws.length == 0 || item.examansws == "") {
            if (required) {
              wxztm.push(index + 1);
            }
          } else {
            let fz = item.zbfz / item.selections.length * parseFloat(item.examansws);
            yxztm.push({
              txdm: item.txdm,
              zbdm: item.zbdm,
              zbmc: item.zbmc,
              zbxmdm: item.selections[item.examansws-1].zbxmdm,
              fz: fz,
              dtjg:this.printChar('★',item.examansws)
            });
            // 选中负分就必须填写意见建议
            if (fz < 0) {
              this.ff = true;
            }
            this.wjpf = this.wjpf + fz;
            xztmsy.push({index: index});
          }
        } else if (item.txdm == "6") //打分
        {
          // 是否选中
          if (item.examansws.length == 0 || item.examansws == "") {
            if (required) {
              wxztm.push(index + 1);
            }
          } else {
            let fz = parseFloat(item.examansws);
            yxztm.push({
              txdm: item.txdm,
              zbdm: item.zbdm,
              zbmc: item.zbmc,
              fz: fz,
              dtjg: item.examansws+""
            });
            // 选中负分就必须填写意见建议
            if (fz < 0) {
              this.ff = true;
            }
            this.wjpf = this.wjpf + fz;
          }
        } else if (item.txdm == "9") //日期
        {
          if (item.examansws.length == 0 || item.examansws == "") {
            if (required) {
              wxztm.push(index + 1);
            } else {
              wxzwd.push(index + 1);
              ts = true;
            }
          } else {
            yxztm.push({
              txdm: item.txdm,
              zbdm: item.zbdm,
              zbmc: item.zbmc,
              fz: 0,
              dtjg: item.examansws+""
            });
          }
        } else { // 单选
          if (item.txdm == "-1") {
            thisQuestionnaireHasR = item.zbdm;
            zdf = (item.zbbh == null || item.zbbh === '') ? -2000 : item.zbbh * 1;
            zgf = (item.zbmc == null || item.zbmc === '') ? 2000 : item.zbmc * 1;
            // 后续判断根据有无输入框判断，所以此处可以更改值
            smzdf = (item.zblxdm == null || item.zblxdm === '') ? -2000 : item.zblxdm * 1;
            smzgf = (item.bz == null || item.bz === '') ? 2000 : item.bz * 1;
            if (item.examansws.length == 0 || item.examansws == "") {
              pfsm = "";
            } else {
              pfsm = item.examansws;
            }
          } else {
            if (item.examansws.length == 0) {
              if (required) {
                wxztm.push(index + 1);
              }
            } else {
              let zbmxval = JSON.parse(item.examansws[0].replaceAll(/\|/g, '"'));
              let fz = parseFloat(zbmxval.fz);
              yxztm.push({
                txdm: item.txdm,
                zbdm: item.zbdm,
                zbmc: item.zbmc,
                zbxmdm: zbmxval.zbxmdm,
                fz: fz,
                dtjg: zbmxval.zbxmmc
              });
              // 选中负分就必须填写意见建议
              if (fz < 0) {
                this.ff = true;
              }
              this.wjpf = this.wjpf + fz;
              xztmsy.push({index: index});
            }
          }
        }
      })
      // 有未完成的题目，提示
      if (wxztm.length > 0) {
        Notify({type: 'danger', message: '第 [' + wxztm.join('、') + '] 题尚未评价，请评价后再提交！'});
        return false;
      }
      if( thisQuestionnaireHasR  == '1'){
        let temp = "", gosub = false, count = 0;
       for(let item of xztmsy){
          count++;
          if(temp == ""){
            temp = item.index;
          }else{
            if(item.index != temp){
              gosub = true;
              break;
            }
          }
        }
        if(!gosub && count > 1){
          Notify({type: 'danger', message: '请不要全部题目选择同一项结果！'});
          return false;
        }
      }
      if(this.wjpf < zdf || this.wjpf > zgf) {
        Notify({type: 'danger', message: "你的评分不在[" + zdf + "~" + zgf + "]区间内!"});
        return false;
      }

      // 评分说明分数段
      if (pfsm=="" && (this.wjpf < smzdf || this.wjpf > smzgf)) {
        Notify({type: 'danger', message: "分数过高或过低! 请在最后给出评价得分反映的情况说明（请多于10个字）"});
        return false;
      }

      // 如果有问答没填且选中了负分
      if(this.ts && this.ff){
        Notify({type: 'danger', message:"您选择了负分项！请在第 [" + wxzwd.join('、') + "] 题给出评价得分反映的主要情况（请多于10个字）"});
        this.ts = false;
        this.ff = false;
        return false;
      }

      // 南方医如果有问答题没填写, 且得分小于60或不小于90
      if (this.ts && (this.wjpf < 60 || this.wjpf >= 90)) {
        Notify({type: 'danger', message:"分数过高或过低! 请在第 [" + wxzwd.join('、') + "] 题给出评价得分反映的主要情况（请多于10个字）"});
        this.ts = false;
        this.ff = false;
        return false;
      }
      //回调函数提交问卷内容
      this.callbak(yxztm,pfsm,this.wjpf);
    }
    ,
    printChar(c, count) {
      // 重复绘制某个字符
      var a = '';
      for (var i = 0; i < count; i++) {
        a += c;
      }

      return a;
    }
  }
}
</script>
<style lang="scss" scoped>
  .main{
    .content{
      padding: 0 .625rem;
      border-bottom: 1px solid rgb(235, 230, 230);
    }
    .title{
      margin-top: .77em;
      margin-bottom: .3em;
      padding: .625rem;
      font-size: 14px;
    }
    padding-bottom: 60px;
  }
  .van-radio-group{
    .van-radio{
      padding: .625rem;
      font-size: 14px;
      border-bottom: 1px solid rgb(235, 230, 230);
      .van-radio__icon{
        &.van-radio__icon--checked{
          .van-icon{
            background-color: #1989fa;
            border-color: #1989fa;
          }
        }
      }
      .van-radio__label{
        color: #212F6E;
      }
    }
  }
  .van-checkbox-group{
    .van-checkbox{
      padding: .625rem;
      font-size: 14px;
      border-bottom: 1px solid rgb(235, 230, 230);
      .van-checkbox__icon{
        &.van-checkbox__icon--checked{
          .van-icon{
            background-color: #1989fa;
            border-color: #1989fa;
          }
        }
      }
      .van-checkbox__label{
        color: #212F6E;
      }
    }
  }
  .van-cell.van-field{
    border: 1px solid rgb(235, 230, 230);
    border-radius: .25rem;
  }
  .custom-button {
    width: 30px;
    color: #fff;
    font-size: 10px;
    line-height: 30px;
    text-align: center;
    background-color: #1989fa;
    border-radius: 100px;
  }
  // 底部标签栏
  .van-tabbar{
    .van-tabbar-item{
      &.van-tabbar-item--active{
        color: #1989fa !important;
      }
      &:first-child,&:last-child{
        color: #1989fa;
        background-color: #ECEDFD;//rgba(1, 1, 1, .6)//#DFE0E6;
        .van-tabbar-item__icon{
          font-size: 1rem;
        }
      }
      &:nth-child(2){
        color: #fff;
        background-color: #1989fa;
        &.van-tabbar-item--active{
          color: #fff !important;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/mobile-evaluate/index.vue